import { useState } from 'react';
import { Card, Heading, Container, Button, Text } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { toaster } from '@/components/ui/toaster';
import api from '@/utils/api';
import { useAuth } from '@/lib/hooks/use-auth';

const CancelSubscription = () => {
  const { changeWorkspace } = useAuth();
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    setLoading(true);
    const response = await api.get(
      `/workspace/${workspaceId}/cancel-subscription?invoice_now=true`,
    );

    if (response.data.data) {
      const resWorkspace = await api.get(`workspace/${workspaceId}`);
      if (resWorkspace.data.data) {
        changeWorkspace(resWorkspace.data.data);
      }
      toaster.create({
        title: 'Workspace account has beend cancelled successfully!',
        type: 'success',
        duration: 3000,
      });
      setTimeout(() => {
        setLoading(false);
        window.location.href = `/${workspaceId}/home`;
      }, 1000);
    }
    setLoading(false);
  };

  return (
    <Container maxW={'xl'}>
      <Card.Root mx={'auto'} width={{ md: '90%' }} maxW={'6xl'}>
        <Card.Header textAlign={'center'} px={0}>
          <Heading size={{ base: 'md', md: 'lg' }}>Cancel Subscription</Heading>
        </Card.Header>
        <Card.Body>
          <Text>
            Are you sure you want to cancel your subscription? This action is irreversible.
          </Text>
        </Card.Body>
        <Card.Footer>
          <Button w={'full'} loading={loading} colorScheme={'red'} onClick={onSubmit}>
            Cancel
          </Button>
        </Card.Footer>
      </Card.Root>
    </Container>
  );
};

export default CancelSubscription;
